import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4964987c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "card"
}
const _hoisted_3 = { class: "header-detail" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "media/icons/chevron-left-circle-bold.svg",
  style: {"width":"25px"},
  alt: ""
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "modal-footer" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14px"} }, " PAY NOW", -1))
const _hoisted_8 = { style: {"background-color":"#ffd600"} }
const _hoisted_9 = { class: "container-invoice" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = {
  class: "d-flex",
  style: {"height":"100%","align-items":"center"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"font-weight":"bolder"} }, "WESERVE", -1))
const _hoisted_13 = { class: "container-invoice" }
const _hoisted_14 = { class: "topic-title" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-right":"2vw"} }, [
  /*#__PURE__*/_createElementVNode("h4", null, "ผู้ออก")
], -1))
const _hoisted_16 = { style: {"margin-left":"2vw","margin-top":"2vh"} }
const _hoisted_17 = {
  class: "title2",
  style: {"height":"12vh"}
}
const _hoisted_18 = { style: {"display":"flex","align-items":"center","height":"10vh"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-right":"2vw"} }, [
    /*#__PURE__*/_createElementVNode("h4", null, "ลูกค้า")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-right":"2vw"} }, [
    /*#__PURE__*/_createElementVNode("h4", null, "ที่อยู่")
  ])
], -1))
const _hoisted_20 = { style: {"margin-left":"6vw"} }
const _hoisted_21 = { style: {"font-weight":"20"} }
const _hoisted_22 = { style: {"font-weight":"20"} }
const _hoisted_23 = { style: {"display":"flex","margin-top":"1.5vh"} }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-right":"2vw"} }, [
  /*#__PURE__*/_createElementVNode("h4", null, "เลขที่ใบกำกับ"),
  /*#__PURE__*/_createElementVNode("h4", null, "วันที่ออก"),
  /*#__PURE__*/_createElementVNode("h4", null, "ครบกำหนด")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title2",
  style: {"height":"5.5vh"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "d-flex",
    style: {"width":"28vw","justify-content":"space-between"}
  }, [
    /*#__PURE__*/_createElementVNode("p", null, "ลำดับที่"),
    /*#__PURE__*/_createElementVNode("p", null, "รายละเอียด")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "จำนวนเงิน")
  ])
], -1))
const _hoisted_26 = {
  class: "titleloop",
  style: {"height":"100%"}
}
const _hoisted_27 = { style: {"width":"5vw","margin-top":"1vw"} }
const _hoisted_28 = { style: {"width":"15vw","margin-top":"1vw"} }
const _hoisted_29 = { style: {"width":"7vw","margin-top":"1vw"} }
const _hoisted_30 = { style: {"margin-left":"4vw"} }
const _hoisted_31 = { class: "title2-noboder" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "หมายเหตุ")
], -1))
const _hoisted_33 = {
  class: "d-flex",
  style: {"width":"20vw","justify-content":"space-between"}
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "จำนวนเงินรวมทั้งสิ้น", -1))
const _hoisted_35 = { style: {"margin-right":"1vw"} }
const _hoisted_36 = { class: "d-flex" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "ตัวอักษร:", -1))
const _hoisted_38 = {
  key: 1,
  class: "card-two"
}
const _hoisted_39 = { class: "header-detail" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "media/icons/chevron-left-circle-bold.svg",
  style: {"width":"25px"},
  alt: ""
}, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "modal-footer" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14px"} }, " PAY NOW", -1))
const _hoisted_44 = { style: {"background-color":"#ffd600"} }
const _hoisted_45 = { class: "container-invoice" }
const _hoisted_46 = { class: "title" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "ใบแจ้งหนี้/ใบวางบิล")
], -1))
const _hoisted_48 = {
  class: "d-flex",
  style: {"height":"100%","align-items":"center"}
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"font-weight":"bolder"} }, "WESERVE", -1))
const _hoisted_50 = { class: "container-invoice" }
const _hoisted_51 = {
  class: "topic-title",
  style: {"justify-content":"space-between"}
}
const _hoisted_52 = {
  class: "d-flex",
  style: {"margin-top":"2vh"}
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-right":"2vw"} }, [
  /*#__PURE__*/_createElementVNode("h4", null, "ผู้ออก")
], -1))
const _hoisted_54 = {
  class: "d-flex",
  style: {"margin-right":"5vw"}
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { style: {"margin-right":"1vw"} }, "เลขประจำตัวผู้เสียภาษี", -1))
const _hoisted_56 = { class: "mt-4 pb-4" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode("ลูกค้า")
const _hoisted_58 = /*#__PURE__*/_createTextVNode("ที่อยู่")
const _hoisted_59 = /*#__PURE__*/_createTextVNode("เลขประจำตัวผู้เสียภาษี")
const _hoisted_60 = /*#__PURE__*/_createTextVNode("เลขที่ใบกำกับ")
const _hoisted_61 = /*#__PURE__*/_createTextVNode("วันที่ออก")
const _hoisted_62 = /*#__PURE__*/_createTextVNode("ครบกำหนด")
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title2",
  style: {"height":"5.5vh","align-items":"center"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "d-flex",
    style: {"width":"25vw","justify-content":"space-between"}
  }, [
    /*#__PURE__*/_createElementVNode("p", null, "ลำดับที่"),
    /*#__PURE__*/_createElementVNode("p", null, "รายละเอียด")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "จำนวน")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "หน่วยละ")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "ส่วนลด")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "จำนวนเงิน")
  ])
], -1))
const _hoisted_64 = {
  class: "",
  style: {"border-bottom":"1px solid #00000029","justify-content":"start"}
}
const _hoisted_65 = { style: {"width":"1vw","margin-left":"1vw","margin-top":"1vw"} }
const _hoisted_66 = { style: {"width":"20vw","margin-top":"1vw","display":"flex","justify-content":"flex-start","margin-left":"4vw"} }
const _hoisted_67 = { style: {"width":"5vw","margin-top":"1vw"} }
const _hoisted_68 = { style: {"margin-left":"2vw"} }
const _hoisted_69 = { style: {"width":"6vw","margin-top":"1vw"} }
const _hoisted_70 = { style: {"margin-left":"5vw"} }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"15vw","margin-top":"1vw"} }, [
  /*#__PURE__*/_createElementVNode("p", null, "0.0")
], -1))
const _hoisted_72 = { style: {"margin-top":"1vw"} }
const _hoisted_73 = { class: "title2-noboder" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "หมายเหตุ")
], -1))
const _hoisted_75 = {
  class: "d-flex",
  style: {"margin-top":"200px"}
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "ตัวอักษร:", -1))
const _hoisted_77 = { class: "d-flex" }
const _hoisted_78 = /*#__PURE__*/_createStaticVNode("<div data-v-4964987c><div style=\"width:10vw;display:flex;justify-content:flex-end;\" data-v-4964987c><p data-v-4964987c>รวมเป็นเงิน</p></div><div style=\"width:10vw;display:flex;justify-content:flex-end;\" data-v-4964987c><p data-v-4964987c>หัก ส่วนลด</p></div><div style=\"width:10vw;display:flex;justify-content:flex-end;\" data-v-4964987c><p data-v-4964987c>ยอดหลังหักส่วนลด</p></div><div style=\"width:10vw;display:flex;justify-content:flex-end;\" data-v-4964987c><p data-v-4964987c>หัก เงินมัดจำ</p></div><div style=\"width:10vw;display:flex;justify-content:flex-end;\" data-v-4964987c><p data-v-4964987c>จำนวนเงินหลังหักมัดจำ</p></div><div style=\"width:10vw;display:flex;justify-content:flex-end;\" data-v-4964987c><p data-v-4964987c>จำนวนภาษีมูลค่าเพิ่ม 7%</p></div><div style=\"width:10vw;display:flex;justify-content:flex-end;\" data-v-4964987c><p data-v-4964987c>จำนวนเงินรวมทั้งสิ้น</p></div></div>", 1)
const _hoisted_79 = { style: {"width":"10vw","display":"flex","justify-content":"flex-end"} }
const _hoisted_80 = { style: {"width":"10vw","display":"flex","justify-content":"flex-end"} }
const _hoisted_81 = { style: {"width":"10vw","display":"flex","justify-content":"flex-end"} }
const _hoisted_82 = { style: {"width":"10vw","display":"flex","justify-content":"flex-end"} }
const _hoisted_83 = { style: {"width":"10vw","display":"flex","justify-content":"flex-end"} }
const _hoisted_84 = { style: {"width":"10vw","display":"flex","justify-content":"flex-end"} }
const _hoisted_85 = { style: {"width":"10vw","display":"flex","justify-content":"flex-end"} }
const _hoisted_86 = { key: 2 }
const _hoisted_87 = { class: "modal-mask" }
const _hoisted_88 = { class: "modal-wrapper" }
const _hoisted_89 = { class: "modal-container" }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/bill.png",
    style: {"height":"140px","width":"140px"}
  })
], -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-content mt-3" }, [
  /*#__PURE__*/_createElementVNode("a", { style: {"color":"#9ea0b1"} }, "Total Amount")
], -1))
const _hoisted_93 = { class: "modal-content" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_95 = { class: "container" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { style: {"color":"#9ea0b1"} }, "ยอดค้างชำระ", -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_98 = { class: "modal-footer" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"color":"white"} }, "PAY NOW", -1))
const _hoisted_100 = [
  _hoisted_99
]
const _hoisted_101 = {
  key: 1,
  class: "loading"
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dots-1" }, null, -1))
const _hoisted_103 = [
  _hoisted_102
]
const _hoisted_104 = { key: 2 }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/bill.png",
    style: {"height":"140px","width":"140px"}
  })
], -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-content mt-3 mb-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { style: {"color":"#4caf50","font-size":"16px"} }, "SUCCESS!"),
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#9ea0b1"} }, "Payment is completed")
], -1))
const _hoisted_107 = { class: "box" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "logo me-1",
    style: {"display":"flex","align-items":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("img", { src: "media/icons/checktrue.svg" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"16px","font-weight":"bold"} }, " ใบแจ้งชำระหนี้ของ Rider "),
    /*#__PURE__*/_createElementVNode("small", { style: {"color":"#9ea0b1"} }, "ยอดค้างชำระ")
  ])
], -1))
const _hoisted_109 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_110 = {
  key: 0,
  style: {"font-size":"16px","font-weight":"bold"}
}
const _hoisted_111 = { class: "footer-1" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#9ea0b1","text-align":"center"} }, " Total Amount ", -1))
const _hoisted_113 = { style: {"text-align":"center"} }
const _hoisted_114 = { key: 0 }
const _hoisted_115 = { key: 3 }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/bill.png",
    style: {"height":"140px","width":"140px"}
  })
], -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-content mt-3 mb-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { style: {"color":"#f44336","font-size":"16px","margin-top":"3vh"} }, " PAYMENT ERROR! "),
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#707070"} }, [
    /*#__PURE__*/_createTextVNode(" Sorry, your transaction has failed. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Please try again later. ")
  ])
], -1))
const _hoisted_118 = { class: "box" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "logo me-1",
    style: {"display":"flex","align-items":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("img", { src: "media/icons/fail.svg" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"16px","font-weight":"bold"} }, " ใบแจ้งชำระหนี้ของ Rider "),
    /*#__PURE__*/_createElementVNode("small", { style: {"color":"#9ea0b1"} }, "ยอดค้างชำระ")
  ])
], -1))
const _hoisted_120 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_121 = {
  key: 0,
  style: {"font-size":"16px","font-weight":"bold"}
}
const _hoisted_122 = { class: "footer-1" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"color":"white"} }, "Done", -1))
const _hoisted_124 = [
  _hoisted_123
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_ctx.isLoadingData == false)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.setbillid.bill_type.bill_type_name === `ใบแจ้งชำระหนี้ของ rider`)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.back())),
                    class: "btn btn-active-white",
                    style: {"position":"absolute","left":"0px","top":"15px"}
                  }, _hoisted_5)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("h2", null, _toDisplayString(`Invoice Detail (ใบแจ้งชำระหนี้ของ Rider#${_ctx.setbillid.bill_number})`), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    class: "btn btn-success",
                    style: {"padding":"2px 10px","margin-right":"2vw"},
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.Popuppage()))
                  }, [
                    _createVNode(_component_inline_svg, { src: "media/icons/billcard.svg" }),
                    _hoisted_7
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h1", null, _toDisplayString(_ctx.setbillid.bill_type.bill_type_name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_inline_svg, {
                        src: "media/icons/monky.svg",
                        style: {"width":"3vw","height":"3vw"}
                      }),
                      _hoisted_12
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.setbillid.bill_issuer_name), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.setbillid.bill_issuer_address), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("h5", _hoisted_21, _toDisplayString(_ctx.setbillid.bill_customer_name), 1),
                      _createElementVNode("h5", _hoisted_22, _toDisplayString(_ctx.setbillid.bill_customer_address), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", null, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.setbillid.bill_number), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.moment(_ctx.setbillid.created_at).format("DD-MM-YYYY")), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.moment(_ctx.setbillid.bill_due_date).format("DD-MM-YYYY")), 1)
                    ])
                  ])
                ]),
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setbillid.bill_detail, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "d-flex",
                      style: {"justify-content":"space-between"}
                    }, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("a", null, _toDisplayString(index + 1), 1)
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("a", null, _toDisplayString(item.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("a", _hoisted_30, _toDisplayString(item.price), 1)
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("h4", _hoisted_35, _toDisplayString(_ctx.setbillid.bill_net_price), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("a", null, _toDisplayString(`(${_ctx.setbillid.bill_net_price_text})`), 1)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.back())),
                    class: "btn btn-active-white"
                  }, _hoisted_41)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("h2", null, _toDisplayString(`Invoice Detail (ใบแจ้งชำระหนี้ #${_ctx.setbillid.bill_number})`), 1)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("button", {
                    class: "btn btn-success",
                    style: {"padding":"2px 10px","margin-right":"2vw"},
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.Popuppage()))
                  }, [
                    _createVNode(_component_inline_svg, { src: "media/icons/billcard.svg" }),
                    _hoisted_43
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("div", _hoisted_48, [
                      _createVNode(_component_inline_svg, {
                        src: "media/icons/monky.svg",
                        style: {"width":"3vw","height":"3vw"}
                      }),
                      _hoisted_49
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createElementVNode("div", null, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.setbillid.bill_issuer_name), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.setbillid.bill_issuer_address), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _createElementVNode("p", null, _toDisplayString(_ctx.setbillid.bill_issuer_tax_id), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createVNode(_component_el_row, { style: {"justify-content":"space-between"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 12,
                        xs: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                span: 8,
                                xs: 24,
                                style: {"font-weight":"bold","font-size":"12px"}
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_57
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                span: 12,
                                xs: 24,
                                style: {"font-size":"12px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.setbillid.bill_customer_name), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                span: 8,
                                xs: 24,
                                style: {"font-weight":"bold","font-size":"12px"}
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_58
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                span: 12,
                                xs: 24,
                                style: {"font-size":"12px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.setbillid.bill_customer_address), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                span: 8,
                                xs: 24,
                                style: {"font-weight":"bold","font-size":"12px"}
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_59
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                span: 12,
                                xs: 24,
                                style: {"font-size":"12px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.setbillid.bill_customer_tax_id), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 12,
                        xs: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                span: 8,
                                xs: 24,
                                style: {"font-weight":"bold"}
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_60
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                span: 12,
                                xs: 24
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.setbillid.bill_number), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                span: 8,
                                xs: 24,
                                style: {"font-weight":"bold"}
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_61
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                span: 12,
                                xs: 24
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.moment(_ctx.setbillid.created_at).format("DD-MM-YYYY")), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                span: 8,
                                xs: 24,
                                style: {"font-weight":"bold"}
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_62
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                span: 12,
                                xs: 24
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.moment(_ctx.setbillid.bill_due_date).format("DD-MM-YYYY")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setbillid.bill_detail, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "d-flex",
                      style: {"justify-content":"space-between"}
                    }, [
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("p", null, _toDisplayString(index + 1), 1)
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("p", null, _toDisplayString(item.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("p", _hoisted_68, _toDisplayString(item.unit), 1)
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("p", _hoisted_70, _toDisplayString(item.price), 1)
                      ]),
                      _hoisted_71,
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("p", null, _toDisplayString(item.price * item.unit), 1)
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", null, [
                    _hoisted_74,
                    _createElementVNode("div", _hoisted_75, [
                      _hoisted_76,
                      _createElementVNode("a", null, _toDisplayString(`(${_ctx.setbillid.bill_net_price_text})`), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _hoisted_78,
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.setbillid.bill_amount_price), 1)
                      ]),
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.setbillid.bill_discount_price), 1)
                      ]),
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.setbillid.bill_amount_price - _ctx.setbillid.bill_discount_price), 1)
                      ]),
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.setbillid.bill_deposit_price), 1)
                      ]),
                      _createElementVNode("div", _hoisted_83, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.setbillid.bill_amount_price -
                    _ctx.setbillid.bill_discount_price -
                    _ctx.setbillid.bill_deposit_price), 1)
                      ]),
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.setbillid.bill_vat_price), 1)
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.setbillid.bill_net_price), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])),
        (_ctx.check)
          ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
              _createVNode(_Transition, { name: "modal" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_87, [
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("div", _hoisted_89, [
                        (_ctx.slidepage)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                              _hoisted_91,
                              _hoisted_92,
                              _createElementVNode("div", _hoisted_93, [
                                _createElementVNode("h1", null, _toDisplayString(`${_ctx.setbillid.bill_amount_price} credit`), 1)
                              ]),
                              _hoisted_94,
                              _createElementVNode("div", _hoisted_95, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("h3", null, _toDisplayString(_ctx.setbillid.bill_type.bill_type_name), 1),
                                  _hoisted_96
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("h3", null, _toDisplayString(_ctx.setbillid.bill_amount_price), 1)
                                ])
                              ]),
                              _hoisted_97,
                              _createElementVNode("div", _hoisted_98, [
                                _createElementVNode("button", {
                                  class: "button",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => {
                      _ctx.slidepage = false;
                      _ctx.toPay(_ctx.setbillid);
                    })
                                }, _hoisted_100),
                                _createElementVNode("h5", {
                                  class: "cancel-text",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.check = false))
                                }, "CANCEL")
                              ])
                            ]))
                          : (_ctx.isLoadingPage)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_101, _hoisted_103))
                            : (_ctx.setbillpaycheck.bill_complete.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                  _createElementVNode("div", null, [
                                    _hoisted_105,
                                    _hoisted_106,
                                    _createElementVNode("div", _hoisted_107, [
                                      _hoisted_108,
                                      _createElementVNode("div", _hoisted_109, [
                                        (_ctx.setbillpaycheck.bill_complete.length > 0)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_110, _toDisplayString(_ctx.setbillpaycheck.bill_complete[0].bill_net_price), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_111, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", null, [
                                          _hoisted_112,
                                          _createElementVNode("h1", _hoisted_113, [
                                            (_ctx.setbillpaycheck.bill_complete.length > 0)
                                              ? (_openBlock(), _createElementBlock("h3", _hoisted_114, _toDisplayString(_ctx.setbillpaycheck.bill_complete[0].bill_net_price +
                              "credit"), 1))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _createElementVNode("button", {
                                          class: "button",
                                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.Done())),
                                          style: {"margin-top":"2vh"}
                                        }, " Done ")
                                      ])
                                    ])
                                  ])
                                ]))
                              : (_ctx.setbillpaycheck.bill_fail.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                    _createElementVNode("div", null, [
                                      _hoisted_116,
                                      _hoisted_117,
                                      _createElementVNode("div", _hoisted_118, [
                                        _hoisted_119,
                                        _createElementVNode("div", _hoisted_120, [
                                          (_ctx.setbillpaycheck.bill_fail.length > 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_121, _toDisplayString(_ctx.setbillpaycheck.bill_fail[0].bill_net_price), 1))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_122, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("button", {
                                            class: "button",
                                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.router.back())),
                                            style: {"margin-top":"2vh"}
                                          }, _hoisted_124)
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}